import { OrganizationDetails as DefaultOrganizationDetails } from "src/components/feature/Onboarding";

const OrganizationDetails = () => {
  return <DefaultOrganizationDetails />;
};

export default OrganizationDetails;
